import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setDone(true);
    } catch {
      toast.error("Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="max-w-reading mx-auto px-6 py-24">
        <div className="eyebrow text-oc-coral mb-6">Contact</div>
        <h1 className="font-editorial text-4xl md:text-6xl text-oc-ink leading-[1.05]">Say hello.</h1>
        <p className="mt-6 font-editorial text-lg text-oc-ink-soft leading-relaxed">
          Press, partnership, editorial feedback, or a note, we read everything.
        </p>

        {done ? (
          <p data-testid="contact-success" className="mt-16 font-editorial text-2xl text-oc-blue">
            Message received. We'll be in touch.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-12 space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <Field label="Name" required value={form.name} onChange={set("name")} testId="contact-name" />
              <Field label="Email" required type="email" value={form.email} onChange={set("email")} testId="contact-email" />
            </div>
            <Field label="Subject" value={form.subject} onChange={set("subject")} testId="contact-subject" />
            <label className="block">
              <span className="eyebrow text-oc-ink-muted mb-2 block">Message *</span>
              <textarea
                data-testid="contact-message"
                rows={7}
                required
                value={form.message}
                onChange={set("message")}
                className="w-full px-4 py-3 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-editorial text-base leading-relaxed resize-y"
              />
            </label>
            <button
              data-testid="contact-submit"
              disabled={loading}
              className="h-14 px-10 bg-oc-ink text-white font-ui text-sm font-bold uppercase tracking-widest hover:bg-oc-blue disabled:opacity-60"
            >
              {loading ? "Sending..." : "Send message"}
            </button>
          </form>
        )}
      </section>
    </div>
  );
}
function Field({ label, value, onChange, required, type = "text", testId }) {
  return (
    <label className="block">
      <span className="eyebrow text-oc-ink-muted mb-2 block">{label}{required && " *"}</span>
      <input
        data-testid={testId}
        type={type}
        required={required}
        value={value}
        onChange={onChange}
        className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui text-base"
      />
    </label>
  );
}
